import styled from 'styled-components';

export const OpenMobileAppBannerStyled = styled.div`
    display: flex;
    align-items: center;
    padding: 16px;
    position: sticky;
    top: 0;
    background: var(--color-surface);
    z-index: 2;
`;

export const OpenMobileAppBannerCloseContainerStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    width: 24px;
    cursor: pointer;
    margin-right: 8px;
    
    svg {
        fill: var(--color-white-60);
    }
`;

export const OpenMobileAppBannerLogoContainerStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 16px;
    border-radius: 16px;
    
    img {
        width: 56px;
        height: 56px;
    }
`;
